export default {
  case_db: 'Database',
  case_title: 'Title of Judgment',
  ap_remarks: 'Remarks',
  srch_doctitle: 'Document Title',
  srch_type: 'Type',
  itemperpage: 'Items per page',
}